import { useEffect, useState } from "react";

export default function useConnectivity({
  windowObject = typeof window === "undefined" ? null : window,
  navigatorObject = typeof navigator === "undefined" ? null : navigator,
} = {}) {
  const [online, setOnline] = useState(navigatorObject?.onLine !== false);

  useEffect(() => {
    const update = () => setOnline(navigatorObject?.onLine !== false);
    windowObject?.addEventListener("online", update);
    windowObject?.addEventListener("offline", update);
    return () => {
      windowObject?.removeEventListener("online", update);
      windowObject?.removeEventListener("offline", update);
    };
  }, [navigatorObject, windowObject]);

  return { online };
}
